export default __webpack_public_path__ + "static/media/hk_flash_pay_banner.b7a044d6.png";